import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { loadHome } from '../../home/home.actions';
import {
  organisationList,
  selectCurrentOrganizationID,
  organisationById,
  userListByOrganisationId,
  selectOrganisations,
} from '../../organisation/organisation.selector';
import {
  addUserToOrganisation,
  setCurrentOrganisationID,
  saveOrganisationColorPalette,
  saveOrganisationFontFamily,
} from '../../organisation/organisation.actions';
import { Organisation } from '../../organisation/organisation.interface';
import { User } from '../../user/user.interface';
import { myUserId, newUserIsLoading, userById } from '../../user/user.selector';
import { Project } from '../../projects/project.interface';
import {
  projectByOrganisationId,
  selectRecentProjets,
} from '../../projects/project.selector';
import { UserSelectorComponent } from '../user-selector/user-selector.component';
import { setNewUserLoading } from '../../user/user.actions';
import { Router } from '@angular/router';
import {
  setCurrentProjectID,
  setNewProjectName,
} from '../../element-editor/store/editor.actions';
import { selectHomeIsLoading } from '../../home/home.reducer';

@Component({
  selector: 'nw-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  orgs$ = this.store.select(organisationList);
  currentOrgId$ = this.store.select(selectCurrentOrganizationID);
  currentOrg$: Observable<Organisation | undefined> = this.currentOrgId$.pipe(
    filter((id): id is string => !!id),
    switchMap(id => this.store.select(organisationById(id))),
  );

  team$: Observable<User[]> = this.currentOrgId$.pipe(
    filter((id): id is string => !!id),
    switchMap(id => this.store.select(userListByOrganisationId(id))),
  );
  projects$: Observable<Project[]> = this.currentOrgId$.pipe(
    filter((id): id is string => !!id),
    switchMap(id => this.store.select(projectByOrganisationId(id))),
  );

  workspaces$ = this.store.select(selectOrganisations);

  homeIsLoading$ = this.store.select(selectHomeIsLoading);
  recentProjects$: Observable<Project[]> =
    this.store.select(selectRecentProjets);

  myUserId$ = this.store.select(myUserId);
  myUser$: Observable<User> = this.myUserId$.pipe(
    filter((id): id is string => !!id),
    switchMap(id => this.store.select(userById(id))),
  );

  showOrgDropdown = false;

  newUserMode = false;
  newUserEmail = '';

  newProjectMode = false;
  newProjectName = '';

  @ViewChild('orgTrigger') orgTrigger?: ElementRef<HTMLElement>;
  @ViewChild('orgDropdown') orgDropdown?: ElementRef<HTMLElement>;

  @ViewChild('newUserInput') newUserInput?: ElementRef<HTMLInputElement>;
  @ViewChild('newProjectInput') newProjectInput?: ElementRef<HTMLInputElement>;
  @ViewChild(UserSelectorComponent) userSelector?: UserSelectorComponent;

  newUserIsLoading$ = this.store.select(newUserIsLoading);
  // Style modal state
  showColorPaletteModal = false;
  editingPaletteEntries: Array<{ key: string; value: string }> = [];
  // New workspace modal state
  showNewWorkspaceModal = false;

  currentOrgId: string;
  constructor(
    private readonly store: Store,
    private router: Router,
  ) {
    this.store.select(newUserIsLoading).subscribe(val => {
      if (!val) {
        this.newUserMode = false;
        this.newUserEmail = '';
      }
    });

    this.homeIsLoading$.subscribe(val => {
      console.log('homeIsLoading', val);
    });

    // this.store.select(selectCurrentOrganizationID).subscribe(id => {
    //   // ------------------------ //
    //   if (!id) {
    //     this.currentOrgId = null;
    //     return;
    //   }
    //   if (this.currentOrgId == id) return;

    //   this.currentOrgId = id;
    //   console.log('currentOrgId', id);

    //   this.router.navigate(['org', id]);
    // });
  }

  getMonogram(name: string) {
    return name
      ?.split(' ')
      .map(part => part[0])
      .slice(0, 2)
      .join('');
  }

  ngOnInit(): void {
    this.store.dispatch(loadHome());

    this.store.dispatch(setCurrentProjectID({ id: null }));

    // If no current org, pick the first one
    // combineLatest([this.orgs$, this.currentOrgId$])
    //   .pipe(
    //     tap(([orgs, currentId]) => {
    //       if (!currentId && orgs && orgs.length > 0) {
    //         this.store.dispatch(setCurrentOrganisationID({ ID: orgs[0].id }));
    //       }
    //     }),
    //   )
    //   .subscribe();

    // Load selected organisation details
    // this.currentOrgId$
    //   .pipe(filter((id): id is string => !!id))
    //   .subscribe(id => this.store.dispatch(loadOrganisationById({ id })));
  }

  submitNewUser() {
    // if (!this.isUserDataFilled(this.newUser)) {
    //   return;
    // }

    // this.newUserMode = false;
    this.store.dispatch(setNewUserLoading({ value: true }));
    this.store.dispatch(
      addUserToOrganisation({
        email: this.newUserEmail,
        role: 'admin',
        // role: this.selectedRole, //
      }),
    );

    // this.newUser = this.getEmptyUser();
  }

  discardNewUser() {
    this.newUserMode = false;
    this.newUserEmail = '';
  }

  getUserName(user: User): string {
    if (user.firstName) {
      return user.firstName + ' ' + user.lastName;
    }
    return user.email;
  }

  toggleOrgDropdown() {
    this.showOrgDropdown = !this.showOrgDropdown;
  }

  onSelectOrg(id: string) {
    if (!id) return;
    this.store.dispatch(setCurrentOrganisationID({ ID: id }));
    this.router.navigate(['org', id]);
    this.showOrgDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.showOrgDropdown) return;
    const target = event.target as Node;
    const inTrigger = this.orgTrigger?.nativeElement.contains(target);
    const inDropdown = this.orgDropdown?.nativeElement?.contains(target);
    if (!inTrigger && !inDropdown) {
      this.showOrgDropdown = false;
    }
  }

  onAddProject() {
    this.newProjectMode = true;
    setTimeout(() => this.newProjectInput?.nativeElement.focus(), 0);
  }

  submitNewProject() {
    const name = (this.newProjectName || '').trim();
    if (!name) return;
    this.store.dispatch(setNewProjectName({ name }));
    this.newProjectMode = false;
    this.newProjectName = '';
    this.router.navigate(['/new']);
  }

  discardNewProject() {
    this.newProjectMode = false;
    this.newProjectName = '';
  }

  // Open the user-selector's panel instead of prompt
  onAddUser() {
    this.newUserMode = true;
    setTimeout(() => this.newUserInput?.nativeElement.focus(), 0);
  }

  // New workspace modal handlers
  openNewWorkspaceModal() {
    this.showNewWorkspaceModal = true;
  }

  closeNewWorkspaceModal() {
    this.showNewWorkspaceModal = false;
  }

  // Style card handlers
  onFontFamilyChange(value: string) {
    console.log('onFontFamilyChange', value);
    const fontFamily = (value || '').trim();
    if (fontFamily) {
      this.store.dispatch(saveOrganisationFontFamily({ fontFamily }));
    }
  }

  openColorPaletteModal() {
    this.currentOrg$.pipe(filter(Boolean), take(1)).subscribe(org => {
      const palette = (org as Organisation).colorPalette || {};
      this.editingPaletteEntries = Object.entries(palette).map(
        ([key, value]) => ({ key, value }),
      );
      if (this.editingPaletteEntries.length === 0) {
        this.editingPaletteEntries = [{ key: 'primary', value: '#111827' }];
      }
      this.showColorPaletteModal = true;
    });
  }

  closeColorPaletteModal() {
    this.showColorPaletteModal = false;
  }

  addColor() {
    this.editingPaletteEntries.push({
      key: 'color-' + (this.editingPaletteEntries.length + 1),
      value: '#000000',
    });
  }

  removeColor(index: number) {
    this.editingPaletteEntries.splice(index, 1);
  }

  saveColorPalette() {
    const colorPalette: Record<string, string> = {};
    for (const { key, value } of this.editingPaletteEntries) {
      const k = (key || '').trim();
      if (!k) continue;
      colorPalette[k] = value || '#000000';
    }
    this.store.dispatch(saveOrganisationColorPalette({ colorPalette }));
    this.showColorPaletteModal = false;
  }
}
